function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

/**
 * Verifica che il master materializzato contenga ancora l'esatto payload
 * ottimistico che il chiamante intende rendere autorevole.
 *
 * L'ordine delle chiavi oggetto è irrilevante; gli array restano ordinati e
 * devono avere la stessa lunghezza. Si confrontano soltanto le chiavi presenti
 * in `expectedPatch`, così i campi gestiti dal server possono coesistere senza
 * indebolire il controllo sui dati scritti dall'utente.
 */
export function masterRowContainsExpectedPatch(
  row: unknown,
  expectedPatch: unknown,
): boolean {
  if (Array.isArray(expectedPatch)) {
    return Array.isArray(row)
      && row.length === expectedPatch.length
      && expectedPatch.every((value, index) =>
        masterRowContainsExpectedPatch(row[index], value));
  }
  if (isRecord(expectedPatch)) {
    if (!isRecord(row)) return false;
    return Object.entries(expectedPatch).every(([key, value]) =>
      masterRowContainsExpectedPatch(row[key], value));
  }
  return Object.is(row, expectedPatch);
}

/**
 * Un conflitto OCC può essere considerato un ACK soltanto quando il server
 * contiene già l'intero payload ottimistico atteso. Senza expectedPatch non
 * esiste una prova sufficiente e il chiamante deve fallire chiuso.
 */
export function matchingMasterConflictConfirmsExpectedPatch(
  serverValue: unknown,
  expectedPatch: Readonly<Record<string, unknown>> | undefined,
): boolean {
  return expectedPatch !== undefined
    && masterRowContainsExpectedPatch(serverValue, expectedPatch);
}
